import Typography from "@mui/material/Typography";

const ClickableText = ({ children, onClick, sx, disabled = false }) => {
  if (disabled) return;

  return (
    <Typography
      variant="caption"
      sx={{
        textDecoration: "none",
        zIndex: 1,
        cursor: "pointer",
        color: "#0066CC",
        "&:hover": {
          textDecoration: "underline",
        },
        ...sx,
      }}
      onClick={onClick}
    >
      {children}
    </Typography>
  );
};

export default ClickableText;
